import React from "react"
import { Box } from "@shared-components/Box/Box"
import { ThemeUIStyleObject } from "theme-ui"
import { AnimatableIconProps } from "@shared-components/AnimatableIcons/types"

const LINE_SPACING = 6
const LINE_HEIGHT = 1
const ICON_WIDTH = 20
const ICON_HEIGHT = 24

const hamburgerIconStyles: ThemeUIStyleObject = {
  position: "relative",
  display: "inline-block",
  width: `${ICON_WIDTH}px`,
  height: `${ICON_HEIGHT}px`,
  verticalAlign: "middle",
}

const hamburgerSymbolStyles = (
  backgroundColor: string
): ThemeUIStyleObject => ({
  position: "relative",
  top: "50%",
  marginTop: `-${LINE_HEIGHT / 2}px`,
  transitionTimingFunction: "ease-in-out",
  transitionDuration: ".2s",
  transitionProperty: "all",
  "&, &:before, &:after": {
    display: "block",
    width: `${ICON_WIDTH}px`,
    height: `${LINE_HEIGHT}px`,
    backgroundColor,
  },
  "&:before, &:after": {
    content: "''",
    position: "absolute",
    transitionTimingFunction: "ease-in-out",
    transitionDuration: ".2s",
  },
  "&:before": {
    top: `-${LINE_SPACING}px`,
    transition: "all .2s ease-in-out",
  },
  "&:after": {
    bottom: `-${LINE_SPACING}px`,
    transition: "all .2s ease-in-out",
  },
})

const hamburgerSymbolStylesActive: ThemeUIStyleObject = {
  "&": {
    backgroundColor: "transparent",
  },
  "&:before": {
    top: 0,
    transition: "transform .2s ease-in-out",
    transform: "rotate(-45deg)",
  },
  "&:after": {
    bottom: 0,
    transition: "transform .2s ease-in-out",
    transform: "rotate(45deg)",
  },
}

const HamburgerIcon: React.FC<AnimatableIconProps> = ({
  toggleIconState,
  color: backgroundColor,
  title,
  ...props
}) => {
  return (
    <Box
      as="span"
      sx={{
        ...hamburgerIconStyles,
      }}
      {...(title && { "aria-label": title })}
      {...props}
    >
      <Box
        as="span"
        sx={{
          ...hamburgerSymbolStyles(backgroundColor as string),
          ...(toggleIconState && { ...hamburgerSymbolStylesActive }),
        }}
        aria-hidden
      />
    </Box>
  )
}

HamburgerIcon.defaultProps = {
  color: "darkGray",
}

export { HamburgerIcon }
